import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';

export const useTypedDispatch = () => useDispatch<AppDispatch | any>();
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
